export const LEGACY_DATA = {
  kicker: "Productized Philanthropy",
  title: "Choose Your Legacy",
  subtitle: "Don't just donate. Adopt an Asset.",
  description:
    "Curate a personalized 'Impact Basket' by selecting specific business units that align with your philanthropic vision.",
};

export const LEGACY_CARDS = [
  {
    key: "food_security",
    icon: "⚗",
    category: "Food Security",
    name: "Mobile Food Cart",
    price_line: "50 Notes — R50,000",
    description: "Commercial-grade grill, POS, GPS, hygiene station",
    bullets: [
      "Immediate self-employment",
      "Township food security",
      "Formalizes informal economy",
    ],
  },
  {
    key: "digital_inclusion",
    icon: "⌁",
    category: "Digital Inclusion",
    name: "Cell Phone Repair Cart",
    price_line: "50 Notes — R50,000",
    description: "Repair toolkit, battery backup, digital marketing tablet",
    bullets: [
      "Bridges digital divide",
      "Services during load-shedding",
      "High-tech youth jobs",
    ],
  },
  {
    key: "creative_economy",
    icon: "▣",
    category: "Creative Economy",
    name: "Production Kit",
    price_line: "20 Notes — R20,000",
    description: "4K camera, workstation, Adobe/CAD, cloud access",
    bullets: [
      "Digital workforce readiness",
      "Global gig economy access",
      "20% ESG inclusion bonus",
    ],
  },
  {
    key: "ngo_digitization",
    icon: "▦",
    category: "NGO Digitization",
    name: "Tap-to-Donate Terminal",
    price_line: "3 Notes — R3,000",
    description: "NFC contactless, impact display, auto settlement",
    bullets: ["Digital donation tin", "Eliminates cash risk", "Automates philanthropy"],
  },
];
